export const environment = {
  production: false,
  versionTag: 'DOCKER',
  configFile: 'assets/config/config.json',
  configSaludFile: 'assets/config/config-salud.json',
  configSaludSeccion: 'salud',
  apis: {
    mnvSegurosSb: '',
    mnvSeguridadSb: '',
    mnvMediadoresSb: '',
  },
  salud: {
    urlSelectorIntellij: '',
    urlLoginIntellij: '',
    urlIntellij: '',
    urlIntellijEmpNumber: -1,
    urlIntellijEmpName: '',
    urlIntellijSecretKey: '',
  }

};
